import { GoMail } from "react-icons/go";
import { IoLocationOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
const Footer = () => {
  const images = [
    {
      id: 1,
      img: "/assests/facebook.png",
      link: "https://www.facebook.com/profile.php?id=61573924983085",
    },
    {
      id: 2,
      img: "/assests/instagram.png",
      link: "https://www.instagram.com/ceviliyar_?igsh=bDRmMzBjNjIwZm14",
    },
    {
      id: 3,
      img: "/assests/youtube.png",
      link: "https://www.youtube.com/@CeviliyarApp",
    },
    { id: 4, img: "/assests/linkedin.png", link: "https://linkedin.com" },
    {
      id: 5,
      icon: <FaXTwitter size={15} color="white" />,
      link: "https://x.com/",
    },
  ];
  return (
    <div className="w-full ">
      <footer
        className="bg-[#0D0D2B] text-white py-2 px-4 mt-10 w-full w-screen"
        style={{
          background: "linear-gradient(90deg, #0D0D2B 0%, #00006F 100%)",
        }}
      >
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-center gap-4 mx-4 mt-10">
          {/* Address Section */}
          <div className="flex flex-col space-y-6 md:w-1/3 ml-2 md:ml-8 lg:ml-8">
            <img
              src="/assests/White_logo.png"
              alt="cevilyar logo"
              className="h-[40px] sm:h-[43px] w-[150px] sm:w-[170px] mb-2 lg:mb-8 md:mb-8"
            />

            <div>
              <h3 className="text-lg font-semibold font-lora mb-4">
                Our Address
              </h3>
              <div className="flex flex-row gap-2">
                <IoLocationOutline size={16} />
                <div>
                  <p className="text-[12px] gap-2 font-montserrat">
                    Level 8 & 9, Olympia Teknos,
                    <br />
                    No 28, SIDCO Industrial Estate,
                    <br />
                    Guindy, Chennai – 600032.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex space-x-4">
              {images.map((item) => (
                <a
                  key={item.id}
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="flex justify-center items-center bg-gray-800 rounded-full p-2 hover:bg-gray-700 transition"
                >
                  {/* <img
                    src={item.img}
                    alt="social icon"
                    className="h-4 w-4 object-contain"
                  /> */}
                  {item.img ? ( // Condition to render image or icon
                    <img
                      src={item.img}
                      alt="social icon"
                      className="h-4 w-4 object-contain"
                    />
                  ) : (
                    item.icon // Render the icon if img is not present
                  )}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Info Section */}
          <div className="flex flex-col space-y-6 sm:space-y-6 mt-[25px] md:mt-[100px] lg:mt-[100px] md:w-1/3">
            <h2 className="text-[16px] sm:text-[16px] font-semibold font-rubik text-[#F2F2F2]">
              Contact Us
            </h2>
            <div className="flex flex-row items-center gap-2">
              <GoMail size={12} className="mt-1" />
              <p>
                <a
                  href="mailto:support@cevilyarapp.in"
                  className="hover:underline font-light text-[12px] sm:text-[14px] text-[#F2F2F2]"
                >
                  support@ceviliyar.in
                </a>
              </p>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="md:w-1/3 mr-2 md:mr-8 lg:mr-8 mt-3 lg:mt-0">
            <p className="text-[18px] md:text-[30px] font-prata lg:text-[30px] fhd:text-[34px] w-[100vh]">
              Bringing Care to Your Doorstep!
            </p>
            <h3 className="text-14px font-semibold font-lora mb-4 mt-[50px]">
              We're Here to Help
            </h3>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Your Full Name"
                className="w-full bg-[#0D0D2B] border border-white-300 rounded-md px-4 py-2 text-sm text-white text-[10px] placeholder-gray focus:outline-none focus:border-blue-500"
              />
              <input
                type="email"
                placeholder="Your Mail ID"
                className="w-full bg-[#0D0D2B] border border-white-300 rounded-md px-4 py-2 text-sm text-white text-[8px] placeholder-gray focus:outline-none focus:border-blue-500"
              />
              <textarea
                placeholder="Your message"
                className="w-full bg-[#0D0D2B] border border-white-300 rounded-md px-4 py-2 text-sm text-white text-[12px] placeholder-gray focus:outline-none focus:border-blue-500 h-24"
              ></textarea>
              <div className="flex justify-center md:justify-end lg:justify-end mt-4">
                <button
                  type="submit"
                  disabled={true}
                  className="
    bg-white 
    text-black 
    px-4 
    py-1 
    rounded-md 
    transition
    hover:bg-gray-300 
    disabled:bg-gray-300 
    disabled:text-gray-500 
    disabled:cursor-not-allowed
  "
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>

        <p className="w-full mt-6 md:w-auto text-center text-[10px] md:text-[14px] lg:text-[14px] text-white font-montserrat flex flex-col md:flex-row md:items-center md:justify-center space-y-2 md:space-y-0 md:space-x-6 pb-10">
          <Link to="/terms" className="text-white text-[12px]  no-underline">
            Terms and Conditions
          </Link>
          <Link
            to="/privacyPolicy"
            className="text-white text-[12px] no-underline"
          >
            Privacy Policy
          </Link>
          <span className="text-[12px] ">
            Copyrights ©2024 Rizz Software Solutions Pvt All rights reserved.
          </span>
        </p>
      </footer>
    </div>
  );
};
export default Footer;
